import * as Yup from 'yup';

export const schema = Yup.object().shape({
  group_id: Yup.number().required(),
  group_name: Yup.string().required(),
  mall_id: Yup.string().required(),

  active: Yup.boolean().required()
});

export const formInitialState = {
  group_id: '',
  group_name: '',
  mall_id: '',
  active: false
};

export const formErrorInitialState = {
  group_idError: false,
  group_nameError: false,
  mall_idError: false,
  activeError: false
};
